import { useTranslation } from "react-i18next";

interface EmptyStateProps {
  message?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ message }) => {
  const { t } = useTranslation("voiceek_ui");

  const displayMessage = message || t("analysis.categorySummary.selectAnalysisTarget");

  return (
    <div className="flex flex-col items-center justify-center w-full pt-[29px]">
      <div className="text-[var(--color_border,#B7B7B7)] text-center font-montserrat text-[32px] font-bold leading-[160%]">
        {displayMessage}
      </div>
    </div>
  );
};
